import { FC, Fragment } from 'react';
import { TableProps } from 'antd';
import { Fx, Layout, Table } from 'Components';
import { DownloadReportButton, LayoutHolder } from 'Pages/Dashboard/components';
import { OverviewGroupSummary } from 'Services/Api/Dashboard/Types';
import { getGroupSummaryColumns } from './columns';
import Heading from '../components/Heading';
import Button from '../components/Button';
import styles from './GroupSummaryTable.module.scss';
import { ReportType } from 'Services/Api/Reports/Types';
import TableDataCard from './TableDataCard';
import { useIsMobile } from 'Hooks';

interface GroupSummaryTableProps {
	data?: OverviewGroupSummary[];
	loading?: boolean;
	title?: string;
	onChange?: TableProps<OverviewGroupSummary>['onChange'];
}

const GroupSummaryTable: FC<GroupSummaryTableProps> = ({
	data = [],
	loading = false,
	title = 'Group Summary',
	onChange
}) => {
	const isMobile = useIsMobile();

	return (
		<LayoutHolder className={styles.tableHolder}>
			<Layout>
				<Layout.Heading className={styles.heading}>
					<Fx align="middle" justify="space-between">
						<Heading title={title} />
						<DownloadReportButton
							reportType={ReportType.OverviewGroupSummary}
						/>
					</Fx>
				</Layout.Heading>
				<Fragment key={`${data?.[0]?.saqStatus || 0}-${data?.[0]?.scanningStatus || 0}`}>
					{isMobile ? data.map((item, index) => <TableDataCard data={item} key={index} loading={loading} />) : <Table<OverviewGroupSummary>
						className={styles.table}
						rowKey="groupName"
						dataSource={data}
						columns={getGroupSummaryColumns()}
						pagination={false}
						loading={loading}
						onChange={onChange}
					/>}
				</Fragment>
			</Layout>
		</LayoutHolder>
	);
};

export default GroupSummaryTable;
